
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Modal,
  MenuItem,
  Select,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Add, Save } from '@material-ui/icons';

import { upperFirst } from '../../../../util';
import styles from './styles';

const fields = ['language', 'level'];
const categories = ['Beginner', 'Intermediate', 'Advanced'];

class AddLanguage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ..._.zipObject(fields, fields.map(() => '')),
      open: props.open,
      mode: props.mode,
    };
    this._handleCategory = this._handleCategory.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { open, mode } = nextProps;
    this.setState({ open, mode });
  }

  _handleCategory(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  renderTextFields(classes) {
    return (
      <div className={classes.textFieldContainer}>
        {
          fields.map(f => {
            if (f === 'level') {
              return (
                <FormControl key={f} className={classes.formControl}>
                  <InputLabel htmlFor="level">Level</InputLabel>
                  <Select
                    value={this.state.category}
                    onChange={this._handleCategory}
                    inputProps={{ name: 'level', id: 'level' }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {
                      categories.map(c =>
                        <MenuItem key={c} value={c}>{upperFirst(c)}</MenuItem>)
                    }
                  </Select>
                </FormControl>
              );
            }
            return (
              <TextField
                id={f}
                key={f}
                label={upperFirst(f)}
                className={classNames(classes.textField, classes[`textField-${f}`])}
                margin="normal"
              />
            );
          })
        }
      </div>
    );
  }

  render() {
    const { onClose, classes } = this.props;
    const { open, mode } = this.state;

    return (
      <Modal
        aria-labelledby="Add Language"
        aria-describedby="Input a new language and add it to the database"
        open={open}
        onClose={() => onClose('edit')}
      >
        <Card className={classes.card}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="title" color="inherit">
                {upperFirst(mode)} a Language
              </Typography>
            </Toolbar>
          </AppBar>
          {this.renderTextFields(classes)}
          <Divider />
          <div className={classes.buttonContainer}>
            <Button
              color="primary"
              variant="raised"
              className={classes.button}
            >
              {
                mode === 'add' &&
                <React.Fragment>
                  <Add className={classes.icon} />
                  Add Language
                </React.Fragment>
              }
              {
                mode === 'edit' &&
                <React.Fragment>
                  <Save className={classes.icon} />
                  Save
                </React.Fragment>
              }
            </Button>
          </div>
        </Card>
      </Modal>
    );
  }
}

AddLanguage.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mode: PropTypes.oneOf(['add', 'edit']).isRequired,
};

export default withStyles(styles)(AddLanguage);



// WEBPACK FOOTER //
// ./src/modules/requests/components/LanguagePopup/index.js